import { createFileRoute } from '@tanstack/react-router';

type Search = {
  locationId?: string;
  list?: 'forms' | 'packets' | 'inbox' | 'sent' | 'archived';
  listType?: 'sent' | 'archived' | 'inbox';
  subCategory?: 'all' | 'completed' | 'needs-review' | 'retry-sync' | 'reviewed' | 'sync-manually';
  submissionId?: string;
  submission_id?: string; //TODO: both of these are referenced. would be good to consolidate
};

/**
 * Route definition for wrapper library
 */
export const Route = createFileRoute('/forms/submissions')({
  validateSearch: (search: Search): Search => {
    return {
      locationId: search.locationId,
      list: search.list,
      listType: search.listType,
      subCategory: search.subCategory,
      submissionId: search.submissionId,
      submission_id: search.submission_id, //TODO: both of these are referenced. would be good to consolidate
    };
  },
});
